import { useTranslation } from 'react-i18next';

import { PaginationLinks } from '../../Shared/types';
import { LinkButton } from '../../Shared/UI/Button';

interface PaginationButtonsProps {
  links: PaginationLinks;
}

export default function PaginationButtons({ links }: PaginationButtonsProps) {
  const { t } = useTranslation();
  return (
    <div className="flex justify-end space-x-2">
      <LinkButton
        className="btn btn-sm btn-primary"
        disabled={!links.prev}
        href={links.prev || '#'}
      >
        {t('backend:back')}
      </LinkButton>
      <LinkButton
        className="btn btn-sm btn-primary"
        disabled={!links.next}
        href={links.next || '#'}
      >
        {t('backend:next')}
      </LinkButton>
    </div>
  );
}
